import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

const useReferralStats = () => {
  const queryResult = useQuery({
    queryKey: ["referral-stats"],
    queryFn: async () => {
      const {
        data: { user },
      } = await supabase.auth.getUser();

      if (!user) return { referralCount: 0 };

      const { count, error } = await supabase
        .from("profiles")
        .select("*", { count: "exact", head: true })
        .eq("referred_by", user.id);

      if (error) {
        console.error("Error fetching referral stats:", error);
        throw error;
      }

      return {
        referralCount: count || 0,
      };
    },
  });

  return queryResult;
};

export default useReferralStats;
